import { createApp } from 'vue'
import "vant/lib/index.css"
import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all.js';
import App from './App.vue'
import router from './router'

// const app = createApp(App);
// app.use(router)
// app.mount('#app')
createApp(App).use(router).mount('#app')
